import { useTheme } from '@mui/material'
import {
  Background,
  Container,
  LeftContainer,
  SettingsButton,
  SettingsText,
  TextContainer,
} from '../../settings-details.styles'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const SettingsPassword = () => {
  const theme = useTheme()

  const user = useSelector((state: RootState) => state.auth.user)

  return (
    <Background theme={theme} background="dark">
      <Container>
        <LeftContainer>
          <TextContainer>
            <SettingsText>Email: </SettingsText>
            <SettingsText variant="bold">{user?.email}</SettingsText>
          </TextContainer>
          <TextContainer>
            <SettingsText>Password: </SettingsText>
            <SettingsText variant="bold">XXXXXXXXX</SettingsText>
          </TextContainer>
        </LeftContainer>
        <SettingsButton variant="contained" size="small">
          Change Password
        </SettingsButton>
      </Container>
    </Background>
  )
}

export default SettingsPassword
